<template>
    <div class="finalizer-state-icon">
        <div v-if="voya" class="fsi" :class="'fsi-' + meta.key" :title="meta.title">
            <span class="material-symbols-outlined fsi-icon">{{ meta.icon }}</span>
            <span v-show="showLabel" class="fsi-label">{{ meta.label }}</span>
        </div>
        <div v-else-if="state == 'Waiting'" class="text-info" title="Gönderim için bekliyor">
            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-clock" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm8-7A8 8 0 1 1 0 8a8 8 0 0 1 16 0z"/>
            <path fill-rule="evenodd" d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"/>
            </svg>
            <span v-show="showLabel">Gönderim için bekliyor</span>
        </div>
        <div v-else-if="state == 'Success'" class="text-success" title="Gönderildi">
            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"/>
            </svg>
            <span v-show="showLabel">Gönderildi</span>
        </div>
        <div v-else-if="state == 'Fail'" class="text-danger" title="Gönderilemedi!">
            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-exclamation-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
            </svg>
            <span v-show="showLabel">Gönderilemedi!</span>
        </div>
        <div v-else-if="state == 'Canceled'" class="text-warning" title="İptal edildi">
            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-dash-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path fill-rule="evenodd" d="M3.5 8a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5z"/>
            </svg>
            <span v-show="showLabel">İptal edildi</span>
        </div>
        <div v-else class="text-info" :title="state">
            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-question-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M5.25 6.033h1.32c0-.781.458-1.384 1.36-1.384.685 0 1.313.343 1.313 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.007.463h1.307v-.355c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.326 0-2.786.647-2.754 2.533zm1.562 5.516c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
            </svg>
            <span v-show="showLabel">{{state}}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        state: String,
        showLabel: Boolean,
        // true ise Voya görünümü (Material ikon ve renkli etiket) kullanılır
        voya: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        meta() {
            switch (this.state) {
                case 'Waiting':
                    return { key: 'info', icon: 'schedule', title: 'Gönderim için bekliyor', label: 'Gönderim için bekliyor' };
                case 'Success':
                    return { key: 'success', icon: 'check_circle', title: 'Gönderildi', label: 'Gönderildi' };
                case 'Fail':
                    return { key: 'danger', icon: 'error', title: 'Gönderilemedi!', label: 'Gönderilemedi!' };
                case 'Canceled':
                    return { key: 'warning', icon: 'remove_circle', title: 'İptal edildi', label: 'İptal edildi' };
                default:
                    return { key: 'info', icon: 'help', title: this.state, label: this.state };
            }
        }
    }
}
</script>
<style scoped>
.finalizer-state-icon span {
    vertical-align: middle;
    padding-left: 6px;
}

.fsi {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.fsi-icon {
    font-size: 22px;
    font-variation-settings: 'FILL' 1;
}

.finalizer-state-icon .fsi-icon,
.finalizer-state-icon .fsi-label {
    padding-left: 0;
}

.fsi-label {
    font-weight: 500;
    font-size: 14px;
}

.fsi-info { color: #097DFF; }
.fsi-success { color: #1E9E57; }
.fsi-danger { color: #DC3545; }
.fsi-warning { color: #F37615; }
</style>
